import { render, staticRenderFns } from "./companyimg.vue?vue&type=template&id=6717b23c&scoped=true&"
import script from "./companyimg.vue?vue&type=script&lang=js&"
export * from "./companyimg.vue?vue&type=script&lang=js&"
import style0 from "./companyimg.vue?vue&type=style&index=0&id=6717b23c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6717b23c",
  null
  
)

export default component.exports